import { RateOptionTicketType } from 'obt-common/types/api/v1/obt/air/air_search_response';
import { useTranslation } from 'react-i18next';

const useGetPolicyLabelText = (ticketType: RateOptionTicketType, isOutOfPolicy: boolean): string => {
  const { t: tt } = useTranslation('WEB');
  const isMultiTicket = ticketType === RateOptionTicketType.MULTI;
  const isSingleTicket = ticketType === RateOptionTicketType.SINGLE;
  if (isMultiTicket && !isOutOfPolicy) {
    return tt('Separate Tickets');
  }
  return isOutOfPolicy && isSingleTicket ? tt('Out of policy') : tt('Out of policy, 1 more');
};

export { useGetPolicyLabelText };
